import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=24f7df1c&scoped=true&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"
import style0 from "./logo.vue?vue&type=style&index=0&id=24f7df1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7df1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLogo: require('/opt/airport.kg/src/components/icon/logo.vue').default})
